import { LocalStorage } from "@/common/storage.ts";
import { MANAGER_PATH } from "@/constant/url-path.ts";
import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ProtectManagerRouter = ({ children }: { children: ReactNode }) => {
  const navigation = useNavigate();
  const accessToken = LocalStorage.getAccessToken();
  const isAuthenticated = !!accessToken;

  useEffect(() => {
    if (!isAuthenticated) {
      LocalStorage.clearAuthenticationStorage();
      navigation(MANAGER_PATH.AUTH.SIGN_IN);
    }
  }, [isAuthenticated, navigation]);

  return <>{isAuthenticated ? children : null}</>;
};

export default ProtectManagerRouter;
